//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { UsesAuthenticatedUser, UsesKintellGroup } from '@/mixins'
import { get } from 'vuex-pathify'
import TheNavigationDrawer from './TheNavigationDrawer'

export default {
  components: { TheNavigationDrawer },
  mixins: [ UsesAuthenticatedUser, UsesKintellGroup ],
  props: {
    absolute: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      pages: {
        // unauthenticated
        becomeAnAdvisor: '/become-an-advisor',
        // authenticated
        search: '/search',
        getInTouch: '/get-in-touch',
        faqs: '/faq',
        dashboard: '/my-kintell/dashboard',
        bookings: '/my-kintell/bookings',
        becomeAdvisor: '/my-kintell/kintell-cards/create',
        myKintellCards: '/my-kintell/kintell-cards',
        myRewards: '/my-kintell/my-rewards',
        calendar: '/my-kintell/my-calendar',
        credits: '/my-kintell/credits',
        personalDetails: '/my-kintell/my-details',
        favourites: '/my-kintell/favourites',
        pricing: '/pricing',
        login: '/sign-in',
        signOut: '/sign-out',
        joinNow: '/join-now',
        articles: '/articles',
      },
      logoUrl: require('~images/kintell-logo.svg'),
      lightLogoUrl: require('~images/kintell-logo-light.svg'),
    }
  },
  computed: {
    ...get({
      awaitingBookingSession: 'myKintell/awaitingBookingSession',
    }),
    classes () {
      return {
        'the-header--dark': this.showDarkHeader,
        'the-header--absolute': this.absolute
      }
    },
    isOnArticles () {
      return this.$route.path.includes('/articles')
    },
    showDarkHeader () {
      return this.isOnArticles
    },
    alertCount () {
      return this.authenticatedUser.stats.alerts + (this.authenticatedUser.stats.bookingActive ? 1 : 0)
    },
    nameTitle () {
      if (!this.authenticatedUser || !this.authenticatedUser.firstName) {
        return ''
      }
      if (this.authenticatedUser.fullName.length <= 15) {
        return this.authenticatedUser.fullName
      }
      return this.authenticatedUser.firstName.length > 15 ? 'My Kintell' : this.authenticatedUser.firstName
    },
    hideSearchField () {
      const routeName = this.$route.name
      // match search page or any group page
      return routeName?.match(/(search|g -.+)/)
    },
    activeLogo () {
      const route = this.$route.name
      // check if the active route name is group route
      if (route.match(/^g(-)[\w]+/)) {
        const kintellGroup = this.$store.getters['kintellGroup/activeKintellGroup']
        return this.getActiveLogoData(kintellGroup)
      } else if (route.match(/^(advisors)(-)[\w]+/)) {
        const activeKintellCard = this.$store.getters['kintellCards/activeKintellCard']
        return this.getActiveLogoData(activeKintellCard?.kintellGroup)
      }

      return this.getActiveLogoData()
    }
  },
  methods: {
    getActiveLogoData (kintellGroup = {}) {
      if (kintellGroup && kintellGroup?.logoUrl) {
        return {
          url: kintellGroup.logoUrl,
          link: `/g/${kintellGroup.slug}`
        }
      } else {
        return {
          url: this.logoUrl,
          link: '/'
        }
      }
    }
  }
}
